import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimengModule } from '../global/primeng.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { NGFontAwesomeModule } from '../global/ngfontawesome.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { SidebarModule } from 'primeng/sidebar';

import { OfferCounterComponent } from './offer-counter/offer-counter.component';
import { OfferDashboardComponent } from './offer-dashboard/offer-dashboard.component';

@NgModule({
  declarations: [OfferCounterComponent, OfferDashboardComponent],
  imports: [
    CommonModule,
    PrimengModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NGFontAwesomeModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    SidebarModule
  ],
  exports: [OfferCounterComponent, OfferDashboardComponent]
  ,
  entryComponents: [OfferCounterComponent, OfferDashboardComponent]
})

export class OfferModule { }
